module.exports = __webpack_public_path__ + "static/media/login-bg.7c02679c.jpg";